import type { IFootTrafficVisitsHistoryRecord } from '@/Interfaces/Attribution/FootTraffic.interface';

const TWO_YEARS_DAYS = 2 * 364; // 728 — preserves weekday alignment

/** Ratio (e.g. 0.15 = +15%) of current period vs same period 2 years prior. Null when prior period has no data. */
export const twoYearBaselineChange = (
  visitsHistory: IFootTrafficVisitsHistoryRecord[],
  dateRangeStart: string,
  dateRangeEnd: string,
): number | null => {
  const start = new Date(dateRangeStart).getTime();
  const end = new Date(dateRangeEnd).getTime();
  const priorStart = start - TWO_YEARS_DAYS * 24 * 60 * 60 * 1000;
  const priorEnd = end - TWO_YEARS_DAYS * 24 * 60 * 60 * 1000;
  let current = 0;
  let prior = 0;
  for (const { weekStartDate, visits } of visitsHistory) {
    const t = new Date(weekStartDate).getTime();
    if (t >= start && t <= end) current += visits;
    if (t >= priorStart && t <= priorEnd) prior += visits;
  }
  if (!prior) return null;
  return (current - prior) / prior;
};
